import Vue from 'vue'

/**
 * A click the browser should handle itself (new tab / new window / download).
 * Mirrors vue-router's own `guardEvent` checks.
 */
const isModifiedClick = (e) =>
  e.metaKey ||
  e.altKey ||
  e.ctrlKey ||
  e.shiftKey ||
  (e.button !== undefined && e.button !== 0)

/**
 * Directive for handling open link in new tab on all accros list
 *
 * <td v-list-link="{ id: promo.id, routeName: 'promo.info', fullPath: `/promos/${promo.id}/details` }" >  </td>
 */
Vue.directive('listLink', {
  inserted: function(el, binding, vnode) {
    const { id, routeName, fullPath, meta } = binding.value

    el.addEventListener('click', (e) => {
      // Let the browser open a new tab/window instead of navigating in place.
      if (isModifiedClick(e)) return

      vnode.context.$router.push({
        name: routeName,
        params: { id: id.toString() },
        meta,
      })
    })

    const anchor = document.createElement('a')

    anchor.setAttribute('href', fullPath)
    anchor.classList.add('row-link')
    // true = let the browser follow the href, false = leave it to the SPA push above.
    anchor.onclick = (e) => {
      return isModifiedClick(e)
    }

    el.appendChild(anchor)
  },
})
